import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

export interface DocumentDetailsResponse {
  id: string;
  project_airport_id: any;
  published: string;

  title: string;
  title_malay: string;
  title_mandarin: string;

  long_description: string;
  long_description_malay: string;
  long_description_mandarin: string;

  short_description: string;
  short_description_malay: string;
  short_description_mandarin: string;

  repeat_for_days: string;
  frequency_count: string;
  frequency_time: string;

  location: string;
  offer: string;
  navigation_link: string;

  start_date: string;
  end_date: string;

  type: string;
  shop_category: string;
  zone: string;
  notification_type: string;
  repeat_type: string;

  image: string;
  banner_image: string;
  square_image: string;

  sequence: string;

  terms_condition: string;
  terms_condition_malay: string;
  terms_condition_mandarin: string;
}

// edit api call
const fetchPageContentDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/promotions-my-airports/${id}`);

  return response?.data[0];
};

const usePageDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["pageContenDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchPageContentDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { usePageDocumentDetails };
